import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/logisticsManage/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsManage/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsManage/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsManage/img/4.avif';
import image5 from '@src/assets/images/solution/logisticsManage/img/5.avif';
import image6 from '@src/assets/images/solution/logisticsManage/img/6.avif';

export default {
  type: 'Construction Solution',

  banner: {
    title: 'Automatic Tracking of Container Truck Locations in Complex Indoor Warehouses',
    desc: 'In large warehouses, you can track container truck locations in real time and instantly check available parking areas.',
  },

  video: {
    title: 'Even in a Complex Warehouse, Trucks Head Straight to Their Destinations',
    desc: 'RTLS tags attached to container trucks work with indoor positioning infrastructure to automatically identify locations. The dashboard shows parking spots and vehicle flow in real time, so workers can start operations without confusion.',
    play: mainVideo,
  },

  func: [
    {
      theme: 'Vehicle Tracking & Location Data Collection',
      title: 'Automatic Identification of Container Truck Locations',
      desc: 'Each truck has an RTLS tag that automatically identifies its location in real time. The coordinates are visualized on the dashboard, so you can accurately grasp the current position and status.',
      sub1: 'High Accuracy',
      icon1: IconRulerGray,
      sub2: 'Real-Time Status Monitoring',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: 'Real-Time Display of Available Parking Zones',
      desc: 'The system automatically analyzes empty parking spots and visually displays them to drivers. Vehicles can move directly to the optimal spot, reducing wait times.',
      sub1: 'Real-Time Location Tracking',
      icon1: IconBinocularsGray,
      sub2: 'Fast Data Integration',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: 'Visualized Routes to Prevent Overlapping Paths',
      desc: 'When multiple vehicles move simultaneously, the expected routes are visualized on-screen to prevent collisions. This helps prevent congestion in workflows and organizes entry and exit routes.',
      sub1: 'Real-Time Location Tracking',
      icon1: IconBinocularsGray,
      sub2: 'High Accuracy',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      theme: 'Automated Operations Management & Evidence Utilization',
      title: 'Container Location Search Function',
      desc: 'Workers can input the container or truck number in the search bar to immediately check its current location. This removes the need for manual searches and speeds up access to the target truck, improving work efficiency.',
      sub1: 'Flexible Area Setting',
      icon1: IconZoneGray,
      sub2: 'Multiple Zone Setup',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: 'Entry/Exit Records & Location History Management',
      desc: 'Each truck’s movement from entry to final position is saved as a timeline. This information can be used later for logistics flow analysis or as proof of entry and exit.',
      sub1: 'Flexible Area Setting',
      icon1: IconZoneGray,
      sub2: 'Multiple Zone Setup',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: 'Real-Time Alerts & Manager Dashboard',
      desc: 'If an abnormal route, long waiting time, or parking outside designated areas occurs, alerts are sent to managers in real time. The dashboard provides an integrated view of the entire situation.',
      sub1: 'Flexible Area Setting',
      icon1: IconZoneGray,
      sub2: 'Multiple Zone Setup',
      icon2: IconTagGray,
      image: image6,
    },
  ],

  subfunc: {
    title: 'Various Functions',
    desc: 'Ensuring worker safety increases efficiency and reduces losses from accidents. ORBRO offers optimal functions to protect construction site workers. The system responds appropriately when workers approach danger zones, accidents occur, or potential risks arise from heavy equipment.',

    data: [
      { icon: IconBinocularsGray, title: 'Container Tracking', desc: 'Tags auto-track & show location.' },
      { icon: IconClockGray, title: 'Dock Status Check', desc: 'AI shows dock cars & spots live.' },
      { icon: IconChartBarGray, title: 'Parking Zone Analysis', desc: 'Show empty spots in real time.' },
      { icon: IconSearch, title: 'Number Search', desc: 'Input number to find car fast.' },
      { icon: IconZoneGray, title: 'Indoor Map View', desc: 'See vehicle on indoor map live.' },
      { icon: IconDashboard, title: 'Live Status Board', desc: 'All spots & status at a glance.' },
      { icon: IconRoute, title: 'Route Visualizer', desc: 'Predict routes, avoid conflict.' },
      { icon: IconClockGray, title: 'Entry/Exit Log', desc: 'Auto save all in/out times.' },
      { icon: IconChartRadius, title: 'Flow Report', desc: 'Auto report for stock flow.' },
      { icon: IconUserCheck, title: 'Work Efficiency', desc: 'Locate fast & work better.' },
    ],
  },

  system: {
    title: 'System Configuration',
    img: rtlsSystem,
  },

  productTitle: 'Product Configuration',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
